<template lang="html">

    <div class="encuestas-view" id="encuestas">

        <h2 class="title">Programas</h2>

        <section class="listado-encuestas container row-between" v-if="programas.length > 0">
            <article class="oferta row-start aifs" v-for="programa in programas">

                <div class="contenedor-imagen">
                    <img :src="programa.urlImagen" :alt="programa.titulo">
                </div>

                <div class="contenedor-textos">

                    <h3 class="empresa" :style="style.colorMediumBlack">{{programa.financiacion}}</h3>

                    <h2 class="title-dato">{{programa.titulo}}</h2>

                    <p v-if="dominios.tiposFormacionAcademica">
                        <template v-for="(estudio, pos) in programa.tiposEstudios">
                            {{(pos == 1) ? 'y' : ''}} {{dominios.tiposFormacionAcademica[estudio]}}
                        </template>
                    </p>

                    <div class="info column-center">
                        <p class="-fecha">{{programa.fechaInicio}} {{(!!programa.fechaFin) ? '-' : ''}}
                            {{programa.fechaFin}}</p>
                        <p class="-duracion">{{programa | duracion}}</p>
                    </div>

                </div>


                <router-link :to="$t('enlaces.programapracticasactivos')+'/'+programa.urlAcceso" class="enlace-cover">
                </router-link>

            </article>
        </section>

        <p v-else class="no-encuestas">No hay programas disponibles</p>


    </div>

</template>

<script lang="js">

    import { mapGetters, mapActions } from 'vuex';

    import encuestaEl from '@/components/parts/encuesta-el';

    export default {
        name: 'modulo-programas',
        computed: {
            ...mapGetters({
                programas: 'getProgramasActivos',
                colors: 'basicColors',
                style: 'getStyles',
                userType: 'getUserType',
                dominios : 'getDominios'
            })
        },
        filters : {
          duracion(value){

            let inicio = (!!value.meses) ? value.meses.split(",")[0] : '';
            let fin = (!!value.meses2) ? value.meses2.split(",")[0] : '';

            let string = inicio;
            string += (!!fin) ? ` ${value.operadorMeses} ${fin}` : '';
            string += (!!fin || inicio != "1") ? ' meses' : ' mes';

            return string;
            
          }
        }
    }
</script>

<style scoped lang="scss">
    .encuestas-view {
        padding: 50px 0;
        width: 100%;
        display: inline-block;
        padding-bottom: 0;
    }

    h2.title {
        font-weight: 800;
        width: 100%;
        font-size: 36px;
        margin-bottom: 25px;
    }


    .oferta{
        position: relative;
        width: 100%;
        padding-top: 20px;
        padding-bottom: 20px;
        .title-dato{
            color:currentColor;
        }

        .-duracion,
        .-fecha{
            padding-left: 20px;
        }

        p:last-child{
            margin-bottom: 0;
        }

        .contenedor-imagen{
            max-width: 300px;
            img{
                width: 100%;
            }
        }

        .contenedor-textos{
            max-width: calc(100% - 140px);
        }
        
    }

    .listado-encuestas {
        width: 100%;
    }

    .no-encuestas {
        width: 100%;
        text-align: center;
    }


    @media screen and (max-width: 767px) {

        .encuestas-view {
            padding: 25px 0;
            width: 100%;
            display: inline-block;
        }

    }

    @media screen and (max-width: 500px) {
        h2.title {
            font-size: 24px;
            margin-bottom: 15px;
        }

        .oferta .contenedor-textos{
            max-width: 100%;
            padding-left: 0;
        }

        .oferta .contenedor-imagen{
            height: auto;
            margin-bottom: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/views/home/modulo-programas.vue